// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpecificStore_wrapper__GSjkH","details":"SpecificStore_details__1hxxV","mapMessage":"SpecificStore_mapMessage__OSskI","map":"SpecificStore_map__q7I7R"};